export const strings = {
  MATCHES: {
    TITLE: 'Matches',
  },
  MATCH_STATUS: {
    ONGOING: 'Pågår',
    FINISHED: 'Slut',
  },
  match_details_scene: {
    yellow_card: 'Gult kort',
    yellow_and_red: 'Gult och rött kort',
    red_card: '',
    goal: '',
    began: 'startade',
    end: 'Slut på',
    started: 'Matchen startade',
    first_cap: 'Första halvlek',
    first: 'första halvlek',
    second_cap: 'Andra halvlek',
    second: 'andra halvlek',
    penalty: 'Rött kort',
    live_video: 'Live video',
    misc_events: 'ÖVRIGA HÄNDELSER',
    goals: 'MÅL',
    warnings: 'VARNINGAR',
    finishes: 'AVSLUT',
    shape: 'Formen',
    kick_off_timeline: 'Avspark',
    paus: 'Paus',
    not_home_team_arena_message_1:
      'Videoklipp från matchen är tillgängliga live när du befinner dig på en arena och är ansluten till fotbollens fria Wi-Fi @fotboll',
    not_home_team_arena_message_2:
      'Utanför arenan blir klipp tillgängliga {dateAvailable}',
    not_home_team_arena_message_3: '24h efter att omgången är avslutad.',
    no_clips_yet: 'Videoklipp visas här när det händer något.',
    no_clips: 'Det finns inga videoklipp för den här matchen.',
    news_for_team: 'NYHETER FÖR',
    events_will_be_shown:
      'Matchhändelser kommer att visas här i takt med att de rapporteras in.',
    lineups_will_be_shown: 'Laguppställningarna är inte tillgängliga än.',
    lineups_missing: 'Vi har tyvärr inga laguppställningar för denna match.',
    other_matches: 'ÖVRIGA MATCHER',
    round_matches: 'Omgångens matcher',
    updating: 'UPPDATERAR',
    updating_in: 'UPPDATERAR OM {{count}}s',
    updating_horizontal: 'Uppdaterar',
    updating_in_horizontal: 'Uppdaterar om {{count}}s',
    kick_off: 'AVSPARK {{time}}',
    interrupted: 'MATCHEN AVBRUTEN!',
    canceled: 'MATCHEN INSTÄLLD!',
    ongoing: 'MATCHEN PÅGÅR!',
    finished: 'MATCHEN ÄR SLUT',
    postponed: 'UPPSKJUTEN',
    days_short: 'D ',
    hours_short: 'H ',
    minutes_short: 'MIN ',
    seconds_short: 'S',
    day: 'DAG',
    days: 'DAGAR',
    seconds: 'SEKUNDER',
    1: 'EN',
    2: 'TVÅ',
    3: 'TRE',
    4: 'FYRA',
    5: 'FEM',
    to_match: 'TILL MATCH!',
    kick_off_in: 'AVSPARK OM',
    match: 'MATCHEN',
    highlights: 'HIGHLIGHTS',
  },
};
